import {NgModule} from '@angular/core';

// App routes
import {RouterModule} from '@angular/router';
import {ROUTES} from './shared/routes/app-routes';

// App state store
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {provideHotStore} from './shared/state/hot-store'
import {AppReducers} from './shared/state/app-reducers';

// Ng Modules
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {TranslateModule} from 'ng2-translate';

// App Modules
import {SharedModule} from './shared/shared-module';
import {CatalogModule} from './catalog/catalog-module';

// Providers
import {LogsService} from './shared/services/logs-service';

// Components
import {AppCmp} from './app.cmp';

// Primeng
import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

import { Ng2Bs3ModalModule } from 'ng2-bs3-modal/ng2-bs3-modal';
import {Ng2PageScrollModule} from 'ng2-page-scroll';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:AppModule'));

/**
 * Initialises all the modules required to start the app.
 */
@NgModule({
  
  
    declarations: [
        AppCmp // Only AppCmp here
    ],
      imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        Ng2Bs3ModalModule,
        RouterModule.forRoot(ROUTES, {useHash: false }),
        TranslateModule.forRoot(),
        provideHotStore(AppReducers),
        StoreDevtoolsModule.instrumentStore({maxAge: 500 }),
        SharedModule,
        CatalogModule,
            Ng2PageScrollModule.forRoot()
    ],
      providers: [
        LogsService
    ],
    bootstrap: [AppCmp]
})
export class AppModule {
    constructor() {
        //'Construct app module');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/app-module.ts